import React from 'react';
import {toast} from 'react-toastify';
import {ClipboardDocumentCheckIcon} from '@heroicons/react/24/outline';

interface IButtonClipboardProps {
  text: string;
}

const ButtonClipboard = ({text}: IButtonClipboardProps) => {
  return (
    <button
      type="button"
      className="border border-primary rounded-md p-1 cursor-pointer hover:brightness-120 active:scale-90 duration-200"
      onClick={() => {
        navigator.clipboard.writeText(text);
        toast.success(`Copied: ${text}`);
      }}>
      <ClipboardDocumentCheckIcon className="size-4 text-primary" />
    </button>
  );
};

export default React.memo(ButtonClipboard);
